export const INTERNAL_LABEL = {
  connected: { text: "Connected", cls: "text-emerald-700" },
  reconnect_required: { text: "Reconnect Required", cls: "text-amber-700" },
  error: { text: "Reconnect Required", cls: "text-amber-700" },
  disconnected: { text: "Not Connected", cls: "text-stone-500" },
  unknown: { text: "Not Connected", cls: "text-stone-500" },
};

export const fmtCheck = (iso) => (iso ? new Date(iso).toLocaleString() : "Never");
